import type { ContentNode, DocumentState } from '../document-types';
import type { NodeHandler, RenderContext } from './types';

export class ParagraphHandler implements NodeHandler {
  readonly type = 'paragraph';

  render(
    _node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    childContent: string,
    _ctx: RenderContext
  ): string {
    return childContent + '\n\n';
  }
}
